import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// No-op lock: supabase-js v2 ships with a `navigator.locks`-based mutex that
// frequently dead-locks against its own background token-refresh — surfacing
// to users as the "Login is busy — please try again in a second" toast (and
// "LockAcquireTimeoutError" / "Body is disturbed or locked" under the hood).
// We don't run any other tab that needs to coordinate auth, so we override
// the lock with a pass-through. Reference: supabase/auth-js GitHub issues
// #762, #846 — the maintainers explicitly recommend a no-op lock when only
// a single tab/process touches auth.
const noopLock = async (_name, _acquireTimeout, fn) => await fn();

// Use the native fetch captured in index.html BEFORE rrweb-recorder /
// Emergent telemetry had a chance to monkey-patch it. Without this, the
// recorder consumes the supabase response body during replay capture and
// supabase-js's own `.clone()` throws "Response body is already used",
// surfacing to users as "Login is busy" and silent 400s.
const nativeFetch = (typeof window !== "undefined" && window.__nativeFetch) || (typeof fetch !== "undefined" ? fetch : undefined);

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    lock: noopLock,
  },
  global: {
    ...(nativeFetch ? { fetch: nativeFetch } : {}),
  },
});

/**
 * Keep localStorage.token in sync with the current Supabase session so
 * existing axios/fetch calls that read localStorage.getItem("token") keep working.
 */
export function syncTokenFromSession(session) {
  if (session?.access_token) {
    localStorage.setItem("token", session.access_token);
  } else {
    localStorage.removeItem("token");
  }
}
